enum QuickResourceType {
  QuickCard = 'quickCard',
  QuickPage = 'quickPage',
  QuickNote = 'quickNote',
}

enum QuickResourceAction {
  setQuickCard = 'setQuickCard',
  setQuickPage = 'setQuickPage',
  setQuickNote = 'setQuickNote',
}

const QuickResourceActions: Record<QuickResourceType, QuickResourceAction> = {
  [QuickResourceType.QuickCard]: QuickResourceAction.setQuickCard,
  [QuickResourceType.QuickPage]: QuickResourceAction.setQuickPage,
  [QuickResourceType.QuickNote]: QuickResourceAction.setQuickNote,
};

export { QuickResourceType, QuickResourceAction, QuickResourceActions };
